export const urls = {
  GET_ALATI: 'KlijentAlat/vrati_klijent_alat_za_id_kupca',
  INSERT_ALAT: 'KlijentAlat/unos_klijent_alat',
  UPDATE_ALAT: 'KlijentAlat/izmena_klijent_alat',
  DELETE_ALAT: 'KlijentAlat/brisanje_klijent_alat',
  INSERT_DOKUMENTA: 'Dokumenta/unos_dokumenta',
  DELETE_DOKUMENT: 'Dokumenta/brisanje_dokumenta_objekta',
  GET_DOKUMENTA: 'Dokumenta/vrati_dokumenta_objekta',
  DOWNLOAD_DOKUMENT:
    'Dokumenta/konvertovanje_base64_sa_id_dokumenta_servisnog_zahteva',
};
